// compare strings in ascending or descending order
export function compareStrings(a: string, b: string, direction: string) {
  return direction === 'ASC' ? a.localeCompare(b) : b.localeCompare(a);
}

// compare booleans in ascending or descending order
export function compareBool(a: boolean, b: boolean, direction: string) {
  return direction === 'ASC' ? Number(a) - Number(b) : Number(b) - Number(a);
}

export function compareNumbers(a: number, b: number, direction: string) {
  return direction === 'ASC' ? a - b : b - a;
}
